// extracted by css-extract-rspack-plugin
export default {"tooltip":"wjMn1tb1t44W7mmq","tooltipContent":"RQud6FEU6PQxUEYu"};